import { makeAutoObservable, runInAction, when, autorun } from "mobx";
import API from "../../../config";
import axios from "axios";
import { commonAxios } from "../CommonAxios";
class MultiSelectStore {
  rootStore; // Store the reference to rootStore
  defaultOption = { value: "select-all", label: "Select All" };
  options = []; // Store options dynamically per key
  selectedValues = []; // Store selected values dynamically per key
  loading = false; // Track loading state per key
  totalMatched = -1; // TotalMatched
  nextCursorMark = ""; // NextCursorMark
  fieldKey; // The Key on SelectBox
  selectAllEnabled = false; //SelectAll Enabled or not
  customOptions = []; // What are the Option user Choosed Manuvally
  inputValue = ""; // The Search Value if anything Present
  inputValueAI = "";
  selectAllIgnored = []; //SelectAll but Some Records are not needed
  allowcustomOptions = true;
  multiselect = true;
  inputValue = "";
  isLoadingScroll = false;
  updatedOptions = [];
  offsetValueOfMultiSelect = 0;
  loadingAI = false;
  constructor(rootStore, fieldKey) {
    this.rootStore = rootStore; // Assign rootStore
    this.fieldKey = fieldKey; // Assign rootStore
    makeAutoObservable(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.pushNewOption = this.pushNewOption.bind(this);
    // this.storeMultiSelectData = this.storeMultiSelectData.bind(this);
    this.restoreSelectedValues = this.restoreSelectedValues.bind(this);
    this.restoreSelectAllIgnored = this.restoreSelectAllIgnored.bind(this);
    this.restoreCustomOptions = this.restoreCustomOptions.bind(this);
    this.restoreSelectAllEnabled = this.restoreSelectAllEnabled.bind(this);
    this.handleClearAll = this.handleClearAll.bind(this);
    autorun(() => {
    })
  }
  async clearOptions() {
    this.options = [];
    this.selectedValues = [];
    this.loading = false;
    this.totalMatched = -1;
    this.nextCursorMark = "";
  }
  async fetchOptions(inputValue = "", OffsetValue) {

    if (this.loading) return;
    runInAction(() => {
      this.loading = true;
    });
    const tempNextCursorMark = this.nextCursorMark || "";
    const payloadMap = this.rootStore.getAllSelectedValues();
    const payloadArray = Array.from(payloadMap.values());
    try {
      const response = await commonAxios(
        "/searchFillter",
        "POST",
        {},
        {
          fillterKey: this.fieldKey,
          nextCursorMark: tempNextCursorMark,
          searchKeyword: inputValue,
          payload: payloadArray,
          tableId:
            this.rootStore.gridStore.tabIndex === 0
              ? this.rootStore.gridStore.tableCompanyId
              : this.rootStore.gridStore.tablePeopleId,
        }
      );
      runInAction(() => {
        this.offsetValueOfMultiSelect = OffsetValue;
        this.setInputValue(inputValue);
        const existingOptions = this.options || [];
        const newOptions = response?.data?.items || [];
        // Add "Select All" if this is the first fetch
        if (this.multiselect) {
          this.updatedOptions = [
            this.defaultOption,
            ...existingOptions,
            ...newOptions,
          ];
        } else {
          this.updatedOptions =
            existingOptions.length === 0 && newOptions.length > 0
              ? [this.defaultOption, ...newOptions]
              : [...existingOptions, ...newOptions];
        }
        // De-duplicate using Map
        const uniqueOptions = [
          ...new Map(this.updatedOptions.map((item) => [item.value, item])).values(),
        ];
        this.options = uniqueOptions;
        // Auto-select all new options if Select All is already enabled
        if (this.selectAllEnabled) {
          const currentSelected = this.selectedValues.map((item) => item.value);
          const newUniqueSelections = uniqueOptions.filter(
            (option) =>
              !currentSelected.includes(option.value) &&
              option.value !== this.defaultOption.value
          );
          this.selectedValues = [
            ...this.selectedValues,
            ...newUniqueSelections,
          ];
        }
        if (response.data.TotalMatching) {
          this.totalMatched = response?.data?.TotalMatching || 0;
        }
        this.nextCursorMark = response?.data?.nextCursorMark || "";
        if (newOptions.some((item) => item.selected === true)) {
          const selectedFromResponse = newOptions.filter(item => item.selected === true);
          const currentSelectedValues = this.selectedValues.map((item) => item.value);
          const uniqueNewSelections = selectedFromResponse.filter(
            (item) => !currentSelectedValues.includes(item.value)
          );
          const combinedSelected = [
            ...this.selectedValues,
            ...uniqueNewSelections,
          ];
          this.selectedValues = [
            ...new Map(combinedSelected.map(item => [item.value, item])).values()
          ];
        }
      });
    } catch (error) {
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  async postextraPayload(field = "") {
    try {
      const payloadMap = this.rootStore.getAllSelectedValues();
      const payloadArray = Array.from(payloadMap.values());
      const tempNextCursorMark = this.nextCursorMark || "";
      const response = await commonAxios(
        "/fillHierarchy",
        "POST",
        {},
        {
          fillterKey: this.fieldKey || field,
          nextCursorMark: tempNextCursorMark,
          searchKeyword: this.inputValue,
          searchKeywordAI: this.inputValueAI,
          payload: payloadArray,
          tableId:
            this.rootStore.gridStore.tabIndex === 0
              ? this.rootStore.gridStore.tableCompanyId
              : this.rootStore.gridStore.tablePeopleId,
        }
      );

    } catch (error) {
    } finally {

    }
  }

  async JobTitleAI(field) {

    try {
      runInAction(() => {
        this.loadingAI = true;
      });
      const payloadMap = this.rootStore.getAllSelectedValues();
      const payloadArray = Array.from(payloadMap.values());
      const tempNextCursorMark = this.nextCursorMark || "";
      const response = await commonAxios(
        "/fillWithAI",
        "POST",
        {},
        {
          fillterKey: field,
          nextCursorMark: tempNextCursorMark,
          searchKeyword: this.inputValue,
          searchKeywordAI: this.inputValueAI,
          payload: payloadArray,
          tableId:
            this.rootStore.gridStore.tabIndex === 0
              ? this.rootStore.gridStore.tableCompanyId
              : this.rootStore.gridStore.tablePeopleId,
        }
      );

      return response;
    } catch (error) {
      console.error(error);
    } finally {
      setTimeout(() => {
        runInAction(() => {
          this.loadingAI = false;
        })
      }, 500);
    }
  }

  handleClearAll() {
    runInAction(() => {
      this.selectedValues = [];
    });
  }
  setmutiselect(value) {
    runInAction(() => {
      this.multiselect = value;
    });
  }
  clearMe() {
    runInAction(() => {
      this.selectedValues = [];
      this.totalMatched = -1;
      this.nextCursorMark = "";
      this.selectAllEnabled = false;
      this.customOptions = [];
      this.inputValue = "";
      this.selectAllIgnored = [];
    });
  }
  setInputValue(value) {
    runInAction(() => {
      this.inputValue = value;
    })
  }

  setInputValueAI(value) {
    runInAction(() => {
      this.inputValueAI = value;
    })
  }

  setOffsetValueOfMultiSelect(value) {
    runInAction(() => {
      this.offsetValueOfMultiSelect = value;
    })
  }
  handleSelectChange({ selected, trigger = false }) {
    runInAction(() => {
      // Normalize selected to array
      const selectedArray = Array.isArray(selected)
        ? selected
        : selected
          ? [selected]
          : [];
      // Get available options (excluding "select-all")
      const availableOptions = this.options.filter(
        (o) => o.value !== "select-all"
      );
      // Case 1: Clear all
      if (selectedArray.length === 0) {
        this.selectedValues = [];
        this.selectAllEnabled = false;
        this.updateCustomOptions();
        return;
      }
      // Check if "select-all" is in current selection
      const isSelectAllSelected = selectedArray.some(
        (o) => o.value === "select-all"
      );
      // Check previous "select-all" state
      const wasSelectAllEnabled = this.selectAllEnabled;
      // Get current selections without "select-all"
      const currentSelections = this.selectedValues.filter(
        (v) => v.value !== "select-all"
      );
      // Case 2: "Select All" was clicked
      if (isSelectAllSelected) {
        if (!wasSelectAllEnabled) {
          // First click - select all available options
          this.selectedValues = [...availableOptions];
          this.selectAllEnabled = true;
        } else {
          // Second click - deselect all
          this.selectedValues = [];
          this.selectAllEnabled = false;
        }
      }
      // Case 3: Manual changes when "Select All" was active
      else if (wasSelectAllEnabled) {
        // Find what was deselected
        const deselected = availableOptions.filter(
          (opt) => !selectedArray.some((sel) => sel.value === opt.value)
        );
        if (deselected.length > 0) {
          // Some options were deselected - turn off "Select All" but keep others
          this.selectAllEnabled = false;
          this.selectedValues = selectedArray.filter(
            (o) => o.value !== "select-all"
          );
        }
      }
      // Case 4: Check if all options are manually selected
      else {
        const allSelected =
          availableOptions.length > 0 &&
          availableOptions.every((opt) =>
            selectedArray.some((sel) => sel.value === opt.value)
          );
        if (allSelected) {
          this.selectedValues = [...availableOptions];
          this.selectAllEnabled = true;
        } else {
          this.selectAllEnabled = false;
          this.selectedValues = selectedArray.filter(
            (o) => o.value !== "select-all"
          );
        }
      }
      this.updateCustomOptions();
    });
    if (trigger) {
      this.rootStore.generateCompanyApi({ triggerKey: trigger });
    }

  }
  getOptions() {
    return this.options || [];
  }
  setOptions(options) {
    runInAction(() => {
      this.options = options;
    });
  }
  setInputValue(inputValue) {
    runInAction(() => {
      this.inputValue = inputValue;
    });
  }
  getSelectedValues() {
    const uniqueValues = [
      ...new Map(
        (this.selectedValues || []).map((item) => [item.value, item])
      ).values(),
    ];
    return uniqueValues;
  }
  isLoading() {
    return this.loading || false;
  }
  restoreSelectAllEnabled(value) {
    runInAction(() => {
      this.selectAllEnabled = value;
    });
  }
  restoreCustomOptions(customOptions) {
    runInAction(() => {
      this.customOptions = customOptions || [];
    });
  }
  restoreSelectAllIgnored(selectAllIgnored) {
    runInAction(() => {
      this.selectAllIgnored = selectAllIgnored || [];
    });
  }
  // restoreSelectedValues(selectedValues) {
  //   return new Promise((resolve) => {
  //     runInAction(() => {
  //       this.selectedValues = [];
  //     });
  //     setTimeout(() => {
  //       const valuesToRestore = selectedValues || [];
  //       const batchSize = 500;
  //       let currentIndex = 0;
  //       const processBatch = () => {
  //         const batch = valuesToRestore.slice(
  //           currentIndex,
  //           currentIndex + batchSize
  //         );
  //         runInAction(() => {
  //           this.selectedValues = [...this.selectedValues, ...batch];
  //         });
  //         currentIndex += batchSize;
  //         if (currentIndex < valuesToRestore.length) {
  //           setTimeout(processBatch, 500);
  //         } else {
  //           resolve();
  //         }
  //       };
  //       processBatch();
  //     }, 2000);
  //   });
  //   // runInAction(() => {
  //   //   this.selectedValues = selectedValues || [];
  //   // });
  // }
  restoreSelectedValues(selectedValues) {
    return new Promise((resolve) => {
      const valuesToRestore = selectedValues || [];
      if (valuesToRestore.length > 500) {
        runInAction(() => {
          this.selectedValues = [];
        });
        setTimeout(() => {
          const batchSize = 500;
          let currentIndex = 0;
          const processBatch = () => {
            const batch = valuesToRestore.slice(
              currentIndex,
              currentIndex + batchSize
            );
            runInAction(() => {
              this.selectedValues = [...this.selectedValues, ...batch];
            });
            currentIndex += batchSize;
            if (currentIndex < valuesToRestore.length) {
              setTimeout(processBatch, 500);
            } else {
              resolve();
            }
          };
          processBatch();
        }, 2000);
      } else {
        runInAction(() => {
          this.selectedValues = valuesToRestore;
        });
        resolve();
      }
    });
  }
  pushNewOption(inputValue) {
    runInAction(() => {
      const newOption = {
        value: inputValue,
        label: inputValue,
        CustomOption: true,
      };

      // Only include options[0] if it exists
      const base = this.options[0] ? [this.options[0]] : [];

      this.options = [...base, newOption, ...this.options.slice(1)];
      this.selectedValues = [...this.selectedValues, newOption];
    });
    this.updateCustomOptions();
  }

  resetNextCursorMark() {
    runInAction(() => {
      this.nextCursorMark = "";
    });
  }
  updateCustomOptions() {
    const customSelected = this.options.filter(
      (option) =>
        option.CustomOption &&
        this.selectedValues.some((sel) => sel.value === option.value)
    );
    runInAction(() => {
      this.customOptions = customSelected;
    });
  }
  setAllowcustomoption(value) {
    runInAction(() => {
      this.allowcustomOptions = value;
    });
  }
  restoreFillter(value) {
    runInAction(() => {
      this.selectedValues = value;
    });
  }
}
export default MultiSelectStore;

